"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateToken = void 0;

// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project

/**
 * This method validates mapbox token.
 * This token provides a simple synchronous validation
 * @param {string} token the Mapbox token to validate
 * @return {boolean} true if token is valid, false otherwise
 */
var validateToken = function validateToken(token) {
  return (token || '') !== '';
};

exports.validateToken = validateToken;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9tYXBib3gtdXRpbHMudHMiXSwibmFtZXMiOlsidmFsaWRhdGVUb2tlbiIsInRva2VuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7QUFDQTs7QUFFQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDTyxJQUFNQSxhQUFhLEdBQUcsU0FBaEJBLGFBQWdCLENBQUNDLEtBQUQ7QUFBQSxTQUE0QixDQUFDQSxLQUFLLElBQUksRUFBVixNQUFrQixFQUE5QztBQUFBLENBQXRCIiwic291cmNlc0NvbnRlbnQiOlsiLy8gU1BEWC1MaWNlbnNlLUlkZW50aWZpZXI6IE1JVFxuLy8gQ29weXJpZ2h0IGNvbnRyaWJ1dG9ycyB0byB0aGUga2VwbGVyLmdsIHByb2plY3RcblxuLyoqXG4gKiBUaGlzIG1ldGhvZCB2YWxpZGF0ZXMgbWFwYm94IHRva2VuLlxuICogVGhpcyB0b2tlbiBwcm92aWRlcyBhIHNpbXBsZSBzeW5jaHJvbm91cyB2YWxpZGF0aW9uXG4gKiBAcGFyYW0ge3N0cmluZ30gdG9rZW4gdGhlIE1hcGJveCB0b2tlbiB0byB2YWxpZGF0ZVxuICogQHJldHVybiB7Ym9vbGVhbn0gdHJ1ZSBpZiB0b2tlbiBpcyB2YWxpZCwgZmFsc2Ugb3RoZXJ3aXNlXG4gKi9cbmV4cG9ydCBjb25zdCB2YWxpZGF0ZVRva2VuID0gKHRva2VuOiBzdHJpbmcpOiBib29sZWFuID0+ICh0b2tlbiB8fCAnJykgIT09ICcnO1xuIl19